import EasyPay from 'modules/easyPay'

export default function EasyPayPage() {
    return (
        <>
            <EasyPay />
        </>
    )
}
